export const GetKey = (value) => {
  try {
    const id = value.split("-")[0];
    return id.trim();
  } catch {
    return "";
  }
};
export const GetKeyArray = (data, prop) => {
  if (data == undefined || data == null || data.length == 0) return "";
  var datain = "";
  data.forEach((item) => {
    datain = datain + item[prop] + ",";
  });
  if (datain == "") return "";
  return datain.substring(0, datain.length - 1);
};

// Función para obtener la clave de un objeto a partir de su valor
export const GetArrKey = (arr, value) => {
  const key = Object.keys(arr).find((key) => arr[key] === value);
  return key;
};

export const GetText = (value) => {
  try {
    const id = value.split("-")[1];

    return id;
  } catch {
    return "";
  }
};
